import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'rh-lib-icons',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IconsComponent { }
